import { CEReportBase } from './ce-report-base'


export class CEReport extends CEReportBase {

}